import React from "react";
import { useTranslation } from "react-i18next";

import { getFormatDate } from "~/libs/getFormatDate";

import { DataRow, DataRows } from "../components/DataRows";
import { formatDisplayValue } from "../model/display";
import { TEmployeeProfileUser, TEmployeeView } from "../model/types";

import s from "../EmployeeProfileView.less";

const renderUserLink = (
  user: TEmployeeProfileUser | null | undefined,
  onClick: (user?: TEmployeeProfileUser | null) => void,
) =>
  user?.fullname ? (
    <button type="button" className={s.linkOrange} onClick={() => onClick(user)}>
      {user.fullname}
    </button>
  ) : (
    formatDisplayValue(null)
  );

interface IParametersViewSectionProps {
  employee: TEmployeeView;
  createdByUser?: TEmployeeProfileUser | null;
  lastEditByUser?: TEmployeeProfileUser | null;
  onOpenCreatedBy: (user?: TEmployeeProfileUser | null) => void;
  onOpenLastEditBy: (user?: TEmployeeProfileUser | null) => void;
}

const ParametersViewSection = ({
  employee,
  createdByUser,
  lastEditByUser,
  onOpenCreatedBy,
  onOpenLastEditBy,
}: IParametersViewSectionProps) => {
  const { t } = useTranslation();

  return (
    <section className={s.sectionCompact}>
      <h2 className={s.sectionTitle}>{t("employee.listTitleParameter")}</h2>
      <DataRows>
        <DataRow label={`${t("employee.resourcesControlUserId")}:`}>
          {formatDisplayValue(employee.ResourcesControlUserId)}
        </DataRow>
        <DataRow label={`${t("employee.ladaAcademiaId")}:`}>
          {formatDisplayValue(employee.ladaAcademiaId)}
        </DataRow>
        <DataRow label={`${t("employee.createdAt")}:`}>
          {employee.createdAt
            ? getFormatDate(String(employee.createdAt), true)
            : formatDisplayValue(null)}
        </DataRow>
        <DataRow label={`${t("employee.profileCreated")}:`}>
          {renderUserLink(createdByUser, onOpenCreatedBy)}
        </DataRow>
        <DataRow label={`${t("employee.profileLastChange")}:`}>
          {employee.lastEditDate
            ? getFormatDate(String(employee.lastEditDate), true)
            : formatDisplayValue(null)}
        </DataRow>
        <DataRow label={`${t("employee.lastEditBy")}:`}>
          {renderUserLink(lastEditByUser, onOpenLastEditBy)}
        </DataRow>
      </DataRows>
    </section>
  );
};

export default ParametersViewSection;
